const BASE = "animate-pulse rounded-md bg-surface-subtle";

/**
 * Loading placeholder. Hidden from assistive tech; pair with a `Loader` or
 * `aria-busy` on the region when the wait needs announcing.
 *
 * @param {object} props
 * @param {string} [props.className] Sizing classes. Without `lines` this sizes the single block
 *   (e.g. "h-24 w-full"); with `lines` it applies to the wrapper.
 * @param {number} [props.lines] Render N stacked text bars (h-4, gap-2); the last bar is 60% wide.
 */
const Skeleton = ({ className = "", lines }) => {
  if (!lines) {
    return <div aria-hidden="true" className={`${BASE} ${className}`.trim()} />;
  }

  return (
    <div aria-hidden="true" className={`flex flex-col gap-2 ${className}`.trim()}>
      {Array.from({ length: lines }, (_, i) => (
        <div
          key={i}
          className={`${BASE} h-4 ${lines > 1 && i === lines - 1 ? "w-3/5" : "w-full"}`}
        />
      ))}
    </div>
  );
};

export default Skeleton;
